module.exports = __webpack_public_path__ + "img/hero-bg-joker_mobile.dd964aeb.jpg";